import api from './api'

/**
 * Verificación en dos pasos de la cuenta propia: `/v1/auth/2fa/*`, las mismas rutas que usa el
 * AdminPanel (una sola 2FA por cuenta). Solo piden sesión, así que funcionan antes de tenerla.
 */
const dosPasosService = {
  // { activado, enrolledAt, obligatorio, requerido }
  async estado() {
    const response = await api.get('/auth/2fa/estado')
    return response.data.data
  },
  // { secreto, otpauthUrl }
  async iniciar() {
    const response = await api.post('/auth/2fa/iniciar')
    return response.data.data
  },
  // { codigosRespaldo, sesion2fa }
  async confirmar(codigo) {
    const response = await api.post('/auth/2fa/confirmar', { codigo })
    return response.data.data
  },
  // { sesion2fa }
  async verificar(codigo) {
    const response = await api.post('/auth/2fa/verificar', { codigo })
    return response.data.data
  },
  async desactivar(codigo) {
    const response = await api.post('/auth/2fa/desactivar', { codigo })
    return response.data.data
  },
}

export default dosPasosService
